import React from "react";
import { Alert, Box, IconButton, Slide, Snackbar, Stack } from "@mui/material";
import { Delete } from "@mui/icons-material";
import Dropzone from "../../components/Dropzone";
import { makeStyles } from "@mui/styles";
import { URLS } from "../../apis/urls";
import { fileUploadConfig } from "../../_helpers/fileUploadConfig";
import { totalFilesSizeIsValid } from "../../_helpers";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const QuestionFileUpload = ({
  q,
  sectionIndex,
  isDisabled = false,
  handleFiles,
}) => {
  const classes = useStyles();
  const files = q.attachments
  const [fileError, setFileError] = useState({
     filesSizeIsInValid: false,
     fileUploadErrorMessage: null,
   });
   const [fileUploading, setFileUploading] = useState(false);
   const {t} = useTranslation()
  if (!q.allowFiles) return null;

const handleFileUpload = async(files) => {
  if (!files || files.length === 0) return;

  const isValid = totalFilesSizeIsValid(files, 25);

  if (!isValid) {
    setFileError({
      filesSizeIsInValid: true,
      fileUploadErrorMessage: "files.total.size.notvalid.error",
    });
    return;
  }
  setFileError({
    filesSizeIsInValid: false,
    fileUploadErrorMessage: null,
  });
  setFileUploading(true)
   handleFiles && await handleFiles(sectionIndex, q, files, "add");
  setFileUploading(false)
};


  const handleRemove = (fileIndex) => {
    handleFiles&& handleFiles(sectionIndex, q, files[fileIndex], "remove");
  };

  return (
    <Box sx={{ mt: 1 }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, 80px)",
          gap: 1,
        }}
>
        <Box sx={{ position: "relative", width: 80, height: 80 }}>
          <Dropzone
            openCamera={false}
            accept={fileUploadConfig.allowedMimeTypes.map((f) => f.mime).join()}
            multiple={true}
            disabled={isDisabled}
            iconClasses={classes.uploadIcon}
            className={classes.dropzone}
            onFilesAdded={handleFileUpload}
            uploading={fileUploading}
          />
        </Box>

        {Array.isArray(files) && files.map((file, idx) => (
            <Box key={idx} sx={{ position: "relative", width: 80, height: 80 }}>
              <Box
                component="img" 
                src={URLS.GET_ATTACHMENT_THUMBNAIL + file.fileId}
                alt={file.fileName}
                style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 8 }}
              />
              <IconButton
                size="small"
                sx={{ position: "absolute", top: -6, right: -6 }}
                onClick={(e) => { e.stopPropagation(); handleRemove(idx); }}
                color="error"
              >
                <Delete fontSize="small" />
              </IconButton>
            </Box>
          ))}
      </Box>
      <Snackbar
        TransitionComponent={(props) => (
                  <Slide {...props} direction="left" />
                )}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={fileError.filesSizeIsInValid}
                onClose={() =>
                  setFileError((p) => ({ ...p, filesSizeIsInValid: false, fileUploadErrorMessage:undefined }))
                }
                autoHideDuration={3000}
                key={"file-size-validation"+ new Date().getTime()}
              >
                <Alert elevation={6} variant="filled" severity="error">
                  {t(fileError.fileUploadErrorMessage)}
                </Alert>
              </Snackbar>
    </Box>
    
  );
};

export default QuestionFileUpload;
const useStyles = makeStyles((theme) => ({
  dropzone: {
    padding: 0,
    height: "100%",
    width: "80px",
  },
  uploadIcon: {
    width: 30,
  },
}));
